import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { ampli } from '../../../../ampli';
import { marketPricePageInfo } from '../../../../constants/pageInfo/pageInfo.constant';
import { useGetMachineSearchData } from '../../../../hooks/api/machines/queries/useGetMachineSearchData.query';

interface IRecommendedSearchKeywordProps {
  searchKeyword: string;
}

export const RecommendedSearchKeyword = ({ searchKeyword }: IRecommendedSearchKeywordProps) => {
  const navigate = useNavigate();

  const { data } = useGetMachineSearchData(
    { q: searchKeyword.trim(), filter: 'hasPriceStatistics=true' },
    {
      enabled: Boolean(searchKeyword.trim()),
    },
  );

  const searchedMachines = data?.hits;

  const renderHighlightedText = (text: string) => {
    if (!searchKeyword) return text;

    const trimmedSearchKeyword = searchKeyword.trim();

    const index = text.toLowerCase().indexOf(trimmedSearchKeyword.toLowerCase());
    if (index === -1) return text;

    const beforeMatch = text.slice(0, index);
    const match = text.slice(index, index + trimmedSearchKeyword.length);
    const afterMatch = text.slice(index + trimmedSearchKeyword.length);

    return (
      <>
        {beforeMatch}
        <MatchedText>{match}</MatchedText>
        {afterMatch}
      </>
    );
  };

  if (searchedMachines && searchedMachines.length !== 0) {
    return (
      <Container>
        {searchedMachines.map((machine) => (
          <RecommnededKeywordWrapper
            key={machine.id}
            onClick={() => {
              ampli.pvmClickMarketPriceRecommendedKeyword({
                search_keyword: `${machine.brandName} ${machine.model}`,
              });
              navigate(`${marketPricePageInfo.searchResultPage.path}?keyword=${machine.brandName} ${machine.model}`, {
                replace: true,
              });
            }}
          >
            <RecommendedKeyword>{renderHighlightedText(`${machine.brandName} ${machine.model}`)}</RecommendedKeyword>
            <SearchButton>
              <SearchButtonText>{'검색'}</SearchButtonText>
            </SearchButton>
          </RecommnededKeywordWrapper>
        ))}
      </Container>
    );
  }

  return null;
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;

  padding: 0px 16px;
`;

const RecommnededKeywordWrapper = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;

  padding: 16px 0px;

  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  cursor: pointer;
`;

const RecommendedKeyword = styled.span`
  flex: 1 0 0;

  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* Body/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;

const MatchedText = styled(RecommendedKeyword)`
  color: var(--Light-Scheme-Monochrome-black, #232429);
`;

const SearchButton = styled.button`
  height: 22px;

  display: flex;
  align-items: center;
  gap: 2px;

  padding: 6px 8px;

  border-radius: var(--radius-round, 80px);
  background: var(--Light-Scheme-Monochrome-grey20, #ececf3);
`;

const SearchButtonText = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);
  text-align: center;

  /* System/Small/s-medium */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 10.2px */
`;
